import navbar from '../modules/navbar';
import masonry from '../modules/masonry';
import ThumbnailBox from '../modules/thumbnails';
import form from '../modules/form';

export default {
  init() {
    // JavaScript to be fired on all pages
    navbar.init();
    masonry.init();
    form.init();

    const thumbnailsNodes = Array.from(document.querySelectorAll('.js-thumbnails-box'));
    if (thumbnailsNodes && thumbnailsNodes.length > 0) {
      thumbnailsNodes.forEach(el => {
        new ThumbnailBox(el);
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js